<div class="card card-sm mb-2">
  <div class="card-body">
    <div class="form-row">
      <div class="col-auto">
        <button (click)="onRemoveItem(itemId)"
                [title]="'Remove' | translate"
                class="btn btn-outline-danger btn-xs">
          <span class="fa-solid fa-trash"></span>
        </button>
      </div>
      <div class="col">
        <strong [innerText]="displayName | translate" [title]="displayName | translate"
                class="truncate d-block">
        </strong>
        <span class="text-muted d-block truncate">
                  <span [innerHTML]="detailsLabel"></span>:
                  <strong [innerHtml]="details" [title]="details"></strong>
                </span>
      </div>
    </div>
  </div>
</div>